

export const isValidSchedule = (val) => {
    if (val == 'No' || val == 'nonscheduled' || val == 'Yes' || val == 'scheduled' || val == 'Not Sure' || val == 'unknown') {
        return false;
    }
    if (val == '' || val == null || val == undefined || val == 0 || val == false || val == 'false') {
        return false;
    }
    return true;
}
export const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
export const romanNumberFormat = (num) => {
    if (!+num)
        return false;
    var digits = String(+num).split(""),
        key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
        roman = "",
        i = 3;
    while (i--)
      roman = (key[+digits.pop() + (i * 10)] || "") + roman;
    return Array(+digits.join("") + 1).join("M") + roman;
}

export const PrintElem=(elem)=> {
   // if(Notification.permission == "granted"){
    var mywindow = window.open('', 'PRINT', 'height=500,width=600');
    mywindow?.document?.write('</head><body >');
    mywindow?.document?.write(document.getElementById(elem).innerHTML);
    mywindow?.document?.write('</body></html>');
    mywindow?.document?.close(); // necessary for IE >= 10
    mywindow?.focus(); // necessary for IE >= 10*/
    mywindow?.print();
    mywindow?.close();
    return true;
//}
  }

export const phoneFormat= (phone,ext)=> {
    if (!phone)
        return phone;
    if (phone.indexOf('(') > -1 && phone.indexOf(')') > -1 && phone.indexOf('-') > -1) {
        if (phone.indexOf('x') > -1 || phone.indexOf('X') > -1) {
            return phone;
        } else if (!ext) {
            return phone;
        } else {
            return phone + ' x ' + ext; // Append extension to already formatted phone number
        }
        } else if (!ext) {
            return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'); // return formatted phone number
        }
        var fPhone = phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        return fPhone + ' x ' + ext;  //// return formatted phone number with extension
    };



